import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for the Lease Table Page (/lease)
 */
export const leaseTableTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_LeaseTable_Welcome_Title"),
    description: t("Tour_LeaseTable_Welcome_Description"),
    target: () => queryTourTarget("lease-table-section"),
    placement: "bottom",
  },
  {
    title: t("Tour_LeaseTable_New_Title"),
    description: t("Tour_LeaseTable_New_Description"),
    target: () => queryTourTarget("lease-new-button"),
    placement: "left",
  },
  {
    title: t("Tour_LeaseTable_Status_Title"),
    description: t("Tour_LeaseTable_Status_Description"),
    target: () => queryTourTarget("lease-status-filter"),
    placement: "bottom",
  },
  {
    title: t("Tour_LeaseTable_Filters_Title"),
    description: t("Tour_LeaseTable_Filters_Description"),
    target: () => queryTourTarget("lease-other-filters"),
    placement: "bottom",
  },
];
